import React from "react";
import { useLang } from "../contexts/LanguageContext";
import SectionHeader from "../components/SectionHeader";

const HERO = "https://static.prod-images.emergentagent.com/jobs/be2064b9-9d7d-4260-b3d4-e04b780abb55/images/d674fcde06ed8375649c122b40877b2edc71287780b0b40fbaaf78fac4093ff5.png";

export default function About() {
  const { t } = useLang();
  return (
    <div data-testid="about-page">
      <SectionHeader
        eyebrow="About"
        title={t.sections.about_title}
        subtitle={t.sections.about_sub}
        image={HERO}
      />
      <div className="max-w-[1100px] mx-auto px-5 lg:px-10 py-16 grid gap-14">
        <Section title={t.about.who_we_are_h} body={t.about.who_we_are} />
        <div className="grid md:grid-cols-2 gap-10">
          <Section title={t.about.vision_h} body={t.about.vision} />
          <Section title={t.about.mission_h} body={t.about.mission} />
        </div>

        <div>
          <div className="label-eyebrow text-ink mb-4">{t.about.objectives_h}</div>
          <ul className="grid gap-3">
            {t.about.objectives.map((o, i) => (
              <li key={i} className="flex gap-4 border-b border-slate200 pb-3">
                <span className="font-mono text-[12px] text-slate500 mt-1">0{i + 1}</span>
                <span className="text-[15px] text-slate700 leading-relaxed">{o}</span>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <div className="label-eyebrow text-ink mb-4">{t.about.areas_h}</div>
          <div className="flex flex-wrap gap-2">
            {t.about.areas.map((a) => (
              <span key={a} className="border border-slate200 px-3 h-9 inline-flex items-center text-[13px] text-slate700">
                {a}
              </span>
            ))}
          </div>
        </div>

        <Section title={t.about.team_h} body={t.about.team_sub} />
      </div>
    </div>
  );
}

function Section({ title, body }) {
  return (
    <div>
      <h2 className="heading-serif text-3xl text-ink mb-4">{title}</h2>
      <p className="text-[16px] text-slate700 leading-relaxed">{body}</p>
    </div>
  );
}
